<template>
  <div class="purchase">
    <div class="purchase__top mb-2">
      <h1 class="text-md-center">{{ productDocument.title }}</h1>

      <div class="d-flex justify-center text-left mb-0">
        <div>
          <ul class="purchase__bullets mb-0">
            <li
              v-for="el in productDocument.bullets"
              :key="el"
              class="text-small"
              data-cy-bullet-el
            >
              {{ el }}
            </li>
          </ul>
        </div>
      </div>
    </div>

    <value-picker
      v-if="pricesDimension.length > 0"
      id="cashPrice"
      v-model="selectedDimensions.price"
      :values="pricesDimension"
      dimension="cash price"
      class="mb-2"
      @input="updateState"
    />

    <primary-button
      id="AddToCart"
      :text="$t('action.buy')"
      align="center"
      with-arrow
      :loading="cartLoading"
      class="mb-1"
      @click="addToCart"
    ></primary-button>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import PrimaryButton from '@/components/buttons/Primary'
import ValuePicker from '@/components/picker/ValuePicker'

import { SHOPIFY_TYPES, SS_UPSELLS_ITEMS } from '@/const'

import ShopifyBase64 from '@/utils/shopifyBase64'

export default {
  name: 'PurchaseGiftCard',
  components: {
    PrimaryButton,
    ValuePicker,
  },
  props: {
    productDocument: { type: Object, required: true },
    shopifyProduct: { type: Object, required: true },
  },
  data() {
    return {
      cardLoading: false,
      selectedDimensions: {
        price: '',
      },
    }
  },
  computed: {
    ...mapGetters({
      cart: 'cart/cart',
      cartLoading: 'cart/isLoading',
    }),
    delivery() {
      return this.shopifyProduct.metafield || undefined
    },
    pricesDimension() {
      if (this.shopifyProduct.isDimensionExist('cash price')) {
        return this.shopifyProduct.variants
      }

      return []
    },
    selectedVariant() {
      if (this.shopifyProduct.variants.length === 1) {
        return this.shopifyProduct.variants[0]
      }
      return this.shopifyProduct.variants.find(
        (v) => v.opt['cash price'].value === this.selectedDimensions.price
      )
    },
    productHasBeenAccessedFromUpsell() {
      if (process.client) {
        let upsellsId = window.sessionStorage.getItem(SS_UPSELLS_ITEMS)
        if (upsellsId) {
          upsellsId = JSON.parse(upsellsId)
          return (
            upsellsId.includes(this.shopifyProduct.id) ||
            this.$route.query.upsell === 'true'
          )
        }
      }
      return this.$route.query.upsell === 'true'
    },
  },
  created() {
    this.selectFirstAvailableVariant()
  },
  methods: {
    ...mapActions({
      addItemToCart: 'cart/addItems',
    }),
    selectFirstAvailableVariant() {
      if (this.$route.query.variant) {
        const variant = this.shopifyProduct.variants.find(
          (v) => v.id === parseInt(this.$route.query.variant)
        )

        if (variant && variant.opt['cash price']) {
          this.selectedDimensions.price = variant.opt['cash price'].value
          return
        }
      }

      if (this.shopifyProduct.isDimensionExist('cash price')) {
        this.selectedDimensions.price =
          this.shopifyProduct.variants[0].opt['cash price'].value
      }
    },
    updateState(updateVariant) {
      if (updateVariant) {
        this.$emit('update-variant', this.selectedVariant)
      } else {
        this.$emit('update-variant')
      }
    },
    addToCart() {
      const customAttributes = []
      customAttributes.push({ key: '_order_type', value: 'preorder' })
      // customAttributes.push({ key: '_delivery', value: this.delivery })
      customAttributes.push({ key: '_slug', value: this.productDocument.uid })
      customAttributes.push({ key: '_locale', value: this.$i18n.locale })

      if (this.productHasBeenAccessedFromUpsell) {
        customAttributes.push({
          key: '_upsell',
          value: 'true',
        })
      }

      const items = []

      const cartItem = {
        merchandiseId: ShopifyBase64.encode(
          SHOPIFY_TYPES.VARIANT,
          this.selectedVariant.id
        ),
        quantity: 1,
        attributes: customAttributes,
      }

      items.push(cartItem)

      // TODO VACS:
      this.addItemToCart(items).then((_) => {
        //   this.$track.addToCart(
        //     this.prismicProduct.name,
        //     this.shopifyProduct,
        //     this.selectedVariant,
        //     this.currency,
        //     this.cart
        //   )

        document
          .getElementById('linkOpenCart')
          .dispatchEvent(new Event('click'))
      })
    },
  },
}
</script>
